<template>
  <b-modal id="ts_assign_worker_modal" ref="ts_assign_worker_modal" hide-footer no-close-on-esc no-close-on-backdrop>
    <div slot="modal-header" class="mh">
      <div id="mh-text">
        <h1><i class="fas fa-street-view"></i> Assign Worker to Site</h1>
      </div>
      <button id="mh-close" class="btn-close" @click="hideModal()"><i class="fas fa-times"></i></button>
    </div>

    <div class="row">
      <div class="col-12">
        Assign a worker to the following site:<br>
        <strong>{{ location }}</strong>
        <hr>
      </div>
      <div class="col-12" v-if="noAssignableJobTitles">
        <p class="mb-0"><strong>This order has ended. Workers cannot be assigned.</strong></p>
      </div>
      <div class="col-12" v-else>
        <ValidationObserver ref="assignWorkerForm" slim>
          <form role="form" @submit.prevent="submit_assign_worker" class="row" autocomplete="off">
            <div class="col-12">
              <p class="mb-1">Search for the worker you wish to assign.</p>
            </div>
            <!-- Multiselect - find worker -->
            <ValidationProvider rules="required" v-slot="{errors, classes}" name="Worker" tag="div" class="col-12 form-group">
              <label class="form-label" for="worker">Worker to Assign</label>
              <multiselect v-model="worker" class="requiredField" :class="classes" id="worker" name="worker" placeholder=""
                           :options="ms_opts.workers" track-by="id" :custom-label="worker_name_label" :show-labels="false">
                <template slot="option" slot-scope="props">
                  <div class="option__desc">
                    <span class="option__title">{{ props.option.person.first_name }} {{ props.option.person.surname }}</span>
                    <span class="option__small" style="float: right;">({{ getReferenceNumber(props.option) }})</span>
                  </div>
                </template>
              </multiselect>
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>
            <!-- The following only shows up once a worker has been selected -->
            <!-- Multiselect - Job Title for worker -->
            <ValidationProvider rules="required" v-slot="{errors, classes}" name="Job Title" tag="div" class="col-12 form-group"
                                v-if="worker !== null">
              <label class="form-label" for="job_title">Job title on site for {{ worker.person.first_name }} {{ worker.person.surname }}</label>
              <multiselect v-model="job_title" class="requiredField" :class="classes" id="job_title" name="job_title" placeholder=""
                           :options="ms_opts.job_titles" label="job_title" track-by="id" @select="selectJobTitle">
              </multiselect>
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>

            <!-- The following only shows up once a job title has been selected -->
            <div class="col-12" v-if="job_title !== null">
              <p class="mb-2 mt-2">Select from the available rates for this job title on this site.<br>
                If the rate does not exist you can add it as a new rate.</p>
            </div>
            <div v-if="job_title !== null" class="col-12">
              <div class="row">
                <!-- Multiselect to choose from existing rates on order_job -->
                <ValidationProvider v-if="ms_opts.existing_rates.length > 0 && !add_new_rate"
                                    rules="required" v-slot="{errors, classes}" name="Pay Rate" tag="div" class="col-12 form-group">
                  <label class="form-label" for="pay_rate">Rate for {{ worker.person.first_name }} {{ worker.person.surname }}</label>
                  <multiselect v-model="existing_rate" class="requiredField" :class="classes" id="pay_rate" name="pay_rate" placeholder=""
                               :options="ms_opts.existing_rates" :custom-label="existing_rate_label" track-by="id" :show-labels="false">
                    <template slot="option" slot-scope="props">
                      <div class="option__desc">
                        <span class="option__title">£ {{ props.option.pay_amount }}</span>
                        <span class="option__small" style="float: right;">({{ props.option.pay_type }})</span>
                      </div>
                    </template>
                    <span slot="noResult" class="noResult" slot-scope="props" @click.prevent="ms_add_new_rate(props.search)">ADD NEW RATE</span>
                  </multiselect>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <!-- Adding a new rate -->
                <div class="col-12" v-else>
                  <div class="row">
                    <!-- If add_rate because the rate does not already exist on the order_job -->
                    <!-- Pay Type -->
                    <ValidationProvider rules="required" v-slot="{errors, classes}" name="Pay Type" tag="div" class="col-6 form-group">
                      <label class="form-label" for="pay_type">Pay Type</label>
                      <multiselect v-model="new_rate.pay_type" class="requiredField" :class="classes"
                                   id="pay_type" name="pay_type" placeholder=""
                                   :options="ms_opts.pay_types" label="value" track-by="id"
                                   :show-labels="false" @select="check_rate_exists" @input="rate_calc_recruitment_margin(new_rate)"></multiselect>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                    <!-- Pay Amount -->
                    <ValidationProvider rules="decimal|required" v-slot="{errors, classes}" name="Pay Amount" tag="div" class="col-6 form-group">
                      <label class="form-label" for="pay_amount">Pay Amount</label>
                      <div class="input-group">
                        <div class="input-group-prepend"><span class="input-group-text">&pound;</span></div>
                        <input type="text" v-model="new_rate.pay_amount" id="pay_amount" name="pay_amount"
                               class="form-input requiredField" :class="[classes, pay_amount_disabled ? 'disabled' : '']" :disabled="pay_amount_disabled"
                               @blur.prevent="check_rate_exists()" @input="rate_calc_recruitment_margin(new_rate)">
                      </div>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="check_all_form_details" class="col-6 offset-6">
              <button type="submit" class="btn orcaBtn" :disabled="saving">
                <span v-if="!saving">Assign Worker</span>
                <span v-else-if="saving"><i class="fas fa-spinner fa-spin"></i> Assigning Worker...</span>
              </button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Multiselect from "vue-multiselect";
import { calculateRate } from 'utils/utils';

export default {
  name: "ts_assign_worker",
  components: {Multiselect},
  props: ['order_jobs'],
  data() {
    return {
      timesheet_order_jobs: this.$store.state.client_timesheets.ts_assign_worker.timesheet_order_jobs,
      company_id: this.$store.state.client_timesheets.ts_assign_worker.company_id,
      location: this.$store.state.client_timesheets.ts_assign_worker.location,
      current_for_work_end_week_date: this.$store.state.client_timesheets.ts_assign_worker.for_work_end_week_date,

      ms_opts: {
        workers: [],
        job_titles: [],
        existing_rates: [],
        pay_types: this.$store.state.crm_options.pay_type,
      },

      worker: null,
      job_title: null,
      order_types: [],

      add_new_rate: false,
      existing_rate: null,
      new_rate: {
        type: {value: 'Basic', id: 15},
        pay_type: null,
        pay_amount: '',
        admin_fee_type: '',
        admin_fee: '',
        retention_percentage: '5',
      },
      pay_amount_disabled: false,

      saving: false,
      noAssignableJobTitles: false,
    }
  },
  async beforeMount() {
    await this.getOrderDetails();
    this.getAssignmentWorkerList();
    await this.getOrderJobTitles();
  },
  computed: {
    check_all_form_details() {
      if (this.noAssignableJobTitles) {
        return false;
      }
      if (this.worker !== null && this.job_title !== null) {
        if (this.add_new_rate && this.new_rate.pay_type !== null && this.new_rate.pay_amount !== '') {
          return true
        }
        else return !this.add_new_rate && this.existing_rate !== null;
      }
      else {
        return false;
      }
    },
  },
  methods: {
    hideModal() {
      this.$refs.ts_assign_worker_modal.hide();
      this.$store.commit('HIDE_ASSIGN_WORKER_MODAL');
    },

    async getOrderDetails() {
        for (const job of this.order_jobs) {
            const order = await axios.get(this.crmApiPath + 'order/job/' + job.id);
            this.order_types.push(order.data.order.order_type);
        }
    },

    /***********************************************************************
     *  Worker
     ***********************************************************************/

    getAssignmentWorkerList() {
      axios.get(this.crmApiPath + 'assignments/company/assignment_worker_list/' + this.company_id, {
        params: {
          order_job_ids: this.timesheet_order_jobs.map(a => a.id)
        }
      }).then(assignments => {

          // map worker employment type to an order type
          let wMapper = {
            'PAYE': 'PAYE',
            'Temporary (PAYE)': 'PAYE',
            'Self Employed (CIS) - Sole Trader': 'Contract',
            'Self Employed - Sole Trader': 'Contract',
            'Limited Company': 'Contract'
          };

          // map order type to employment types
          let oMapper = {
            'Contract': ['Contract'],
            'Internal': ['N/A'],
            'Payroll - Contract': ['Contract'],
            'Payroll - PAYE': ['PAYE'],
            'Permanent': ['Contract', 'PAYE'],
            'Temporary (PAYE)': ['PAYE']
          };

          assignments.data.forEach((worker) => {
              let workerType = wMapper[worker.rel_company_info.employment_type.value] ?? 'N/A';
              let orderTypes = [];
              this.order_types.forEach(type => {
                  let mapped = oMapper[type] ?? [];
                  orderTypes.push(...mapped);
              });
              
              if (orderTypes.includes(workerType)) {
                 this.ms_opts.workers.push(worker);
              }
          });
      });
    },

    worker_name_label({person}) {
      return `${person.first_name} ${person.surname}`;
    },

    getReferenceNumber(worker) {
      // check employment status of worker and if they have a company ref number
      // (if limited company use company_internal_finance_ref)
      if (worker.rel_company_info.employment_type_id === 32 && worker.rel_company_info.company_internal_finance_ref !== null) {
        return `${worker.rel_company_info.company_internal_finance_ref}`
      }
      // if not limited company use worker_internal_finance_ref
      return `${worker.internal_finance_ref}`
    },

    /***********************************************************************
     *  Job Titles
     ***********************************************************************/

    getOrderJobTitles() {
      return axios.get(this.crmApiPath + 'order/position/get_order_job_titles', {
        params: {
          order_job_ids: this.timesheet_order_jobs.map(a => a.id)
        }
      }).then(job_titles => {
        this.ms_opts.job_titles = job_titles.data;
        this.noAssignableJobTitles = !job_titles.data.length;
      });
    },

    selectJobTitle() {
      this.$nextTick(() => {
        this.add_new_rate = false;
        this.ms_opts.existing_rates = [];
        this.existing_rate = null;
        this.new_rate = {
          type: {value: 'Basic', id: 15},
          pay_type: null,
          pay_amount: '',
          admin_fee_type: '',
          admin_fee: '',
          retention_percentage: '5',
        };
        this.pay_amount_disabled = false;
        if (this.job_title !== null) {
          this.get_order_position_rates(this.job_title.order_job_id)
        }
      })
    },

    /***********************************************************************
     *  Rates
     ***********************************************************************/

    get_order_position_rates(order_job_id) {
      axios.get(this.crmApiPath + 'order/position_rate/get/' + order_job_id).then(rates => {
        this.ms_opts.existing_rates = rates.data.rates
      })
    },

    existing_rate_label({pay_amount, pay_type}) {
      return `£ ${pay_amount}` + ` ` + ` ` + ` ` + `(${pay_type})`
    },

    ms_add_new_rate(search_value) {
      this.new_rate.pay_amount = search_value
      this.add_new_rate = true;
      this.existing_rate = null;
    },
    check_rate_exists() {
      this.$nextTick(() => {
        if (this.new_rate.pay_type !== null) {
          let check = this.ms_opts.existing_rates.filter(rate => rate.pay_amount === parseFloat(this.new_rate.pay_amount) && rate.pay_type === this.new_rate.pay_type.value);
          if (check.length > 0) {
            this.popup_rate_exists(this.new_rate.pay_type.value, this.new_rate.pay_amount)
          }
        }
      });
    },
    popup_rate_exists(pay_type, pay_amount) {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Rate Already Exists</div>' +
            '<div class="snotifyToast__body">' +
            'This position on this site already has a £' + pay_amount + ' (' + pay_type + ') rate' + '<br><br>' +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'Select Rate', action: (toast) => {
              this.add_new_rate = false;
              this.existing_rate = this.ms_opts.existing_rates.filter(rate => rate.pay_amount === parseFloat(this.new_rate.pay_amount) && rate.pay_type ===
                  this.new_rate.pay_type.value)[0];
              this.$snotify.remove(toast.id);
            }
          },
        ]
      });
    },

    // Calculate margin for recruitment crm / recruitment orders
    rate_calc_recruitment_margin(rate) {
      this.$nextTick(() => {
        rate.admin_fee = calculateRate(rate.pay_amount, this.crmType, this.job_title.order_type, this.job_title.recruitment_margin_perc);
      })
    },

    /***********************************************************************
     *  Submit
     ***********************************************************************/

    async submit_assign_worker() {
      this.saving = true;
      let temp_assignment = {
        worker_id: this.worker.id,
        company_id: this.job_title.company_id,
        order_job_id: this.job_title.order_job_id,
        position_rate_id: '',
        // Set assigned by values for creating the worker (current crm user)
        assigned_by_type: 'App\\Models\\Users\\User',
        assigned_by_id: this.$store.state.auth.me.id,
        start_date: this.$moment.utc(this.current_for_work_end_week_date).subtract(5, 'days').format('YYYY-MM-DD'),
        end_date: this.job_title.end_date,
        assigned: true,
        // No GANG LEADER / GANGER FUNCTIONALITY YET
        is_gang_leader: false,
        gang_leader_id: null,
        // Set log values for creating the worker (current crm user)
        log_by_type: 'App\\Models\\Users\\User',
        log_by_id: this.$store.state.auth.me.id
      }
      // if an existing rate is chosen set the position_rate_id on the assignment object
      if (this.existing_rate !== null) {
        temp_assignment.position_rate_id = this.existing_rate.id
      }
      // create new rate and set position_rate_id on the assignment object
      else {
        let position_rate = {
          order_job_id: this.job_title.order_job_id,
          rate_type: this.new_rate.type.value,
          pay_type: this.new_rate.pay_type.value,
          pay_amount: this.new_rate.pay_amount,
          admin_fee_type: this.ms_opts.existing_rates[0].admin_fee_type,
          admin_fee_amount: this.ms_opts.existing_rates[0].admin_fee_amount,
          retention_percentage: this.new_rate.retention_percentage,
          log_by_type: 'App\\Models\\Users\\User',
          log_by_id: this.$store.state.auth.me.id
        };
        await axios.post(this.crmApiPath + 'order/position_rate', position_rate).then(position_rate_id => {
          temp_assignment.position_rate_id = position_rate_id.data
        });
      }

      // save new assignment and create timesheet_records etc
      axios.post(this.crmApiPath + 'assignments/worker_assignments', temp_assignment).then(() => {
        // get email address for worker
        axios.get(this.crmApiPath + 'contact_info/email/worker/' + this.worker.id).then(emails => {
          // send assignment email if there is an email address for the worker
          if (emails.data.website_login !== null) {
            axios.post(this.crmApiPath + 'worker/email/all-assignments', {
              first_name: this.worker.person.first_name,
              email: emails.data.website_login.email_address,
              all_assignments: [{assignment: temp_assignment}]
            });
          }
          
        })

        // reload location
        this.$emit('reload-location-details');

        // hide the modal
        this.hideModal();

      });
    }
  },
  watch: {
    'new_rate.pay_type'(type) {
      if (type !== null) {
        // Price - pay type, set pay amount to 1 and disable input
        if (this.new_rate.pay_type.id === 24) {
          this.new_rate.pay_amount = 1;
          this.pay_amount_disabled = true;
        }
        // for all other pay types, enable pay_amount input
        else {
          // this.new_rate.pay_amount = '';
          this.pay_amount_disabled = false;
        }
      }
    }
  }
}
</script>

<style lang="scss">
#ts_assign_worker_modal {
  .multiselect__option {
    &:hover, &:focus, &:active, &:active:focus, &.active:focus,
    &.focus, &:active.focus, &.active.focus {
      background: $bc_1;
      color:      $white;
    }
  }

  .noResult {
    margin:      -10px -30px -10px -15px;
    padding:     10px 15px;
    height:      38px;
    line-height: inherit;
    display:     block;
    width:       100%;

    &:hover, &:focus, &:active, &:active:focus, &.active:focus,
    &.focus, &:active.focus, &.active.focus {
      color:      $white;
      background: $bc_1;
    }
  }
}
</style>
